import { createSlice } from 'utils/@reduxjs/toolkit';
import { SelectedItemState } from './types';
import { reducers } from './reducers';

export const initialState: SelectedItemState = {
  1: {
    item: null,
  },
  2: { item: null },
  3: { item: null },
  4: { item: null },
  5: { item: null },
};

const slice = createSlice({
  name: 'itemValues',
  initialState,
  reducers,
});

export const { actions: selectedItemActions } = slice;
export const { reducer: selectedItemReducer } = slice;
